import React, { useState, useEffect } from 'react'
import { ReportHeading, LoaderWrapper, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { useExportToPptObjects } from '../../../../hooks/useExportToPptObjects'
import { useGlobalStore } from '../../../../store'
import ReportEditBusiness from './reportEditBusiness'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import { defaultPptxSettings, convertHtmlToPptJson } from '../../../reportsPpt/commonFunctions'
import decode from 'unescape'
import { OuterWrapper, InnerWrapper, ContentWrapper } from './style'

let count = 0
const removeTags = (str) => {
  let data = str
  const replaceArray = [
    '<STRONG>',
    '</STRONG>',
    '<strong>',
    '</strong>',
    '<STRIKE>',
    '</STRIKE>',
    '<strike>',
    '</strike>',
    '<S>',
    '</S>',
    '<s>',
    '</s>',
    '<EM>',
    '</EM>',
    '<em>',
    '</em>',
    '<SUB>',
    '</SUB>',
    '<sub>',
    '</sub>',
    '<SUP>',
    '</SUP>',
    '<sup>',
    '</sup>',
    '<UNDERLINE>',
    '</UNDERLINE>',
    '<underline>',
    '</underline>',
  ]
  if (typeof data === 'string') {
    data = str.split('<ul>')[0]
    data = data.replaceAll('<sup>TM</sup>', ' ').replaceAll('<SUP>TM</SUP>', ' ')
    for (let r = 0; r < replaceArray.length; r++) {
      data = data.replaceAll(replaceArray[r], '')
    }
    data = data
      .replaceAll('<BR />', ' ')
      .replaceAll('<br />', ' ')
      .replaceAll('<BR>', ' ')
      .replaceAll('<br>', ' ')
    data = data
      .replaceAll('&nbsp;', ' ')
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '\/')
      .replaceAll('&apos;', "'")
    data = data
      .replace(/<\/?span[^>]*>/g, '')
      .replace(/<\/?div[^>]*>/g, '')
      .replace(/<\/?p[^>]*>/g, '')
  }
  return data
}
const nodeJsonMainFunc = async (nodes) => {
  let excelData = []
  const nodeJsonFunc = (nodes, parentNode) => {
    let obj = {}
    if (parentNode === 'UL' || parentNode === 'ULUL' || parentNode === 'ULULUL') {
      obj = []
    }

    for (let i = 0; i < nodes.length; i++) {
      const loopNode = nodes[i]
      let tag = loopNode.nodeName

      if (tag === 'DIV') {
        const txt = loopNode?.childNodes[0]?.nodeValue
        if (txt?.trim().length !== 0) {
          count++
          excelData.push(txt)
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content:
              loopNode?.childNodes?.length > 0 ? [nodeJsonFunc(loopNode.childNodes, tag)] : [],
          }
        }
      }
      if (tag === 'UL') {
        count++
        const tagNew = parentNode === 'LILI' ? 'ULULUL' : parentNode === 'LI' ? 'ULUL' : tag
        obj[tag + count] = {
          tag: tagNew,
          content:
            loopNode?.childNodes?.length > 0 ? nodeJsonFunc(loopNode.childNodes, tagNew) : [],
        }
      }
      if (tag === 'LI') {
        const txt = removeTags(loopNode.innerHTML)
        if (txt?.trim().length !== 0) {
          const tagNew = parentNode === 'ULULUL' ? 'LILILI' : parentNode === 'ULUL' ? 'LILI' : tag
          const txtDash = parentNode === 'ULULUL' ? '----- ' : parentNode === 'ULUL' ? '-- ' : ''
          excelData.push(txtDash + txt)
          obj.push({
            tag: tagNew,
            text: txt,
            content:
              loopNode?.childNodes?.length > 1 ? nodeJsonFunc(loopNode.childNodes, tagNew) : '',
          })
        }
      }
      if (tag === 'P') {
        const txt = removeTags(loopNode.innerHTML) + ''
        if (txt?.trim().length !== 0) {
          count++
          if (!(parentNode === 'LI' || parentNode === 'LILI' || parentNode === 'LILILI')) {
            excelData.push(txt)
          }
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'H4') {
        const txt = removeTags(loopNode.innerHTML) + ''
        if (txt?.trim().length !== 0) {
          count++
          excelData.push(txt + '######')
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'HR') {
        count++
        obj[tag + count] = {
          tag: tag,
          text: '',
          content: '',
        }
      }
    }
    return obj
  }
  await nodeJsonFunc(nodes)
  return excelData
}

const ReportBusiness = (props) => {
  const [loading, setLoading] = useState(true)
  const [pageData, setPageData] = useState()
  const [htmlToJsonData, setHtmlToJsonData] = useState()
  const { user, projectIdValue, isPPTModalActive, exportToPptObject, setExportToPptObject } = useGlobalStore()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { updatingExportToPptObject } = useExportToPptObjects()

  /*
    const useReactQueryObject = {
        payloadDetails: {
            queryId: [props.InsightsElementType, props.InsightsElementId],
            urlFunc: ReportsService.reportGetBusinessObjectiveApi,
            payload: { insightsElementId:props.InsightsElementId }
        }
    }
    const { data, isLoading, isSuccess, isError, error, refetch, isRefetching } = useReactQuery(useReactQueryObject)
    */

  const removingTags = (str) => {
    let d1 = str
    if (isPPTModalActive) {
      const htmlNode = document.querySelectorAll(`#${props.type} *`)
      for (let i = 0; i < htmlNode.length; i++) {
        htmlNode[i].removeAttribute('style')
      }
      const htmlStr = document
        .getElementById(props.type)
        .innerHTML.replaceAll('<ol', '<ul')
        .replaceAll('</ol>', '</ul>')
      document.getElementById(props.type).innerHTML = htmlStr
    }
    return d1
  }

  const loadBusinessObjective = (getLatest = false) => {
    setLoading(true)
    ReportsService.reportGetBusinessObjectiveApi(
      { insightsElementId: props.InsightsElementId },
      getLatest
    )
      .then((resp) => {
        setPageData(decode(resp.replace(/<\/?div[^>]*>/g, '')))
        setLoading(false)
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
        setLoading(false)
      })
  }

  const htmlToJson = (pageData) => {
    const data = pageData
    if (props.type && data.length > 10) {
      const rte = document.getElementById(props.type).childNodes[0].childNodes
      const jsonObj = nodeJsonMainFunc(rte)
      jsonObj.then((data) => {
        const dataArray = data.map((v) => {
          return { value: v }
        })
        setHtmlToJsonData(dataArray)
      })
    }
    return null
  }

  const onSuccessEdit = () => {
    loadBusinessObjective(true)
    // refetch()
  }

  const BusinessEditButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && !loading && !projectIdValue?.IsFreezed && (
          <ReportEditBusiness
            InsightsElementId={props.InsightsElementId}
            pageData={pageData || ''}
            onSuccess={onSuccessEdit}
            title={props.Title}
          />
        )}
      </>
    )
  }

  const generatePptObjectFunc = async () => {
    const key = props.InsightsElementType + '__' + props.InsightsElementId.replaceAll('-', '_')
    const id = document.getElementById(props.type)
    if (id) {
      const originalHTML = id.innerHTML
      const json = convertHtmlToPptJson(id, {
        bulletList: ['25AA', '25BA', '25CC', '25AA', '25CC'],
        componentType: 'businessObjective',
      })
      id.innerHTML = originalHTML
      json.then(function (resultArray) {
        const finalResultArray = []
        let checkNewLine = []
        for (let i = 0; i < resultArray.length; i++) {
          if (resultArray[i].type === 'HR') {
            finalResultArray.push(checkNewLine)
            checkNewLine = []
          } else {
            checkNewLine.push(resultArray[i])
          }
        }
        finalResultArray.push(checkNewLine)
        const obj = { [key]: finalResultArray }
        updatingExportToPptObject(obj)
        setTimeout(() => {
          updateSubLhsApiLoaded(props)
          id.innerHTML = originalHTML
        }, 2000)
      })
    }
  }

  useEffect(() => {
    if (!pageData) {
      loadBusinessObjective()
    }
  }, [pageData])

  useEffect(() => {
    if (pageData?.length) {
      // htmlToJson(pageData)
      // removingTags(pageData)
    }
  }, [pageData])

  useEffect(() => {
    generatePptObjectFunc()
  }, [isPPTModalActive && loading])

  /*
    const onSuccessFunc = (resp) => {
        const decodedData = decode(resp.replace(/<\/?div[^>]*>/g, ""))
        setPageData(decodedData)
        setTimeout(() => {
            htmlToJson(decodedData)
            removingTags(decodedData)
            generatePptObjectFunc()
        }, 2000)
    }

    useEffect(() => {
        if(isSuccess && data?.length) onSuccessFunc(data)
    }, [isSuccess, data])
    */

  return (
    <>
      <ReportHeading
        downloadId={props.type}
        downloadIdData={htmlToJsonData}
        subHeading=''
        {...props}
        additionalMiddleButton={<BusinessEditButton />}
        addTable={false}
      />
      <ReportOuterWrapper>
        <OuterWrapper>
          {/* <LoaderWrapper loadOnlyApi={props.loadOnlyApi} isLoading={isLoading} isSuccess={isSuccess} isError={isError} error={error}> */}
          <LoaderWrapper loadOnlyApi={props.loadOnlyApi} loading={loading}>
            <InnerWrapper id={props.type}>
              <ContentWrapper dangerouslySetInnerHTML={{ __html: pageData }} />
            </InnerWrapper>
          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportBusiness
